export const invoicesEn = {
  //BEGIN Michael
  INVOICE: 'Invoice',
  INVOICES: 'Invoices',

  ONLY_CLIENTS_WITH_INVOICES_SHOWN: 'Only clients with invoices are shown here.',
  ONLY_CLIENTS_BROKERS_WITH_INVOICES_SHOWN: 'Only clients/brokers with invoices are shown here.',
  ONLY_DEBTORS_WITH_INVOICES_SHOWN: 'Only debtors with invoices are shown here.',

  PENDING: {
    SINGLE: 'Pending',
    PLURAL: 'Pending',
  },

  APPROVED_FOR_FUNDING: {
    SINGLE: 'Approved for Funding',
    PLURAL: 'Approved for Funding',
  },

  FUNDED: {
    SINGLE: 'Funded',
    PLURAL: 'Funded',
  },

  PAID: {
    SINGLE: 'Paid',
    PLURAL: 'Paid',
  },

  INVOICE_NUMBER: 'Invoice Number',
  REFERENCE_NUMBER: 'Reference Number',
  BALANCE: {
    SINGLE: 'Balance',
    PLURAL: 'Balances',
  },
  TOTAL_INVOICES_PAYMENT: 'Total Invoices Payment',
  ESCROW: 'Escrow',
  INVOICE_BALANCE: 'Invoice Balance',
  REMAINING_INVOICE_BALANCE: 'Remaining Balance',
  ADVANCE_AMOUNT: 'Advance Amount',
  BATCH_AMOUNT: 'Batch Amount',
  ESCROW_RESERVE_AMOUNT: 'Escrow Reserve Amount',
  CASH_RESERVE_AMOUNT: 'Cash Reserve Amount',
  REMAINING_CREDIT_LIMIT: 'Remaining Credit Limit',
  PURCHASE_FEE_AMOUNT: 'Purchase Fee Amount',
  ESCROW_FEE_AMOUNT: 'Escrow Fee Amount',
  ADVANCE_AMOUNT_CANNOT_BE_NEGATIVE: 'Total advance amount cannot be negative',
  INVOICE_FEE: 'Invoice Fee',
  ACH_FEES: 'ACH Fee',
  WIRE_FEES: 'Wire Fee',
  CHECK_FEES: 'Check Fee',
  FUEL_CARD_FEES: 'Fuel Card Fee',
  SAME_DAY_ACH_FEES: 'Same Day ACH Fee',
  INVOICES_APPROVED_FOR_FUNDING_SUCCESSFULLY: 'Invoices approved for funding successfully!',
  REJECTED: 'Rejected',
  REJECT: 'Reject',
  REJECT_INVOICE: 'Reject Invoice',
  INVOICE_REJECTED_SUCCESSFULLY: 'Invoice/s rejected successfully!',
  INVOICE_PENDING_SUCCESSFULLY: 'Invoice/s moved to pending successfully!',
  REJECT_CONFIRMATION: 'Are you sure you want to reject these invoices?',
  UNLINK_FUEL_ADVANCE_CONFIRMATION:
    'One or more of the selected invoices have a Fuel Advance attached. Rejecting will unlink the Fuel Advance and set it back to Open status. Do you want to continue?',
  UNLINK_AND_REJECT: 'Unlink & Reject',
  PENDING_CONFIRMATION: 'Are you sure you want to move to pending these invoices?',
  INVOICES_WERE_SELECTED_FOR_THIS_ACTION: 'invoices were selected for this action',
  MOVE_TO_PENDING: 'Move to Pending',
  MOVE_TO_REJECTED: 'Move to Rejected',
  DEBTOR_CREDIT_LIMIT: 'Debtor Credit Limit',
  CLIENT_DEBTOR_CREDIT_LIMIT: 'Client-Debtor Credit Limit',
  DEBTOR_CREDIT: 'Debtor Credit',
  CLIENT_DEBTOR_CREDIT: 'Client-Debtor Credit',
  DEBTOR_CREDIT_INFO: 'Debtor Credit Info',
  CLIENT_DEBTOR_CREDIT_INFO: 'Client-Debtor Credit Info',
  DEBTOR_CREDIT_SCORE: 'Debtor Credit Score',
  AVERAGE_DAYS_TO_PAY: 'Average Days to Pay',
  INVOICES_RISK_PAST_DUE: 'Invoices at Risk of Past Due',
  INVOICES_PAST_DUE: 'Invoices Past Due',
  NO_LIMIT: 'No Limit',
  SPLIT: 'SPLIT',
  SPLIT_FUNDING: 'Split Funding',
  SPLIT_PAYMENT_AMOUNT_NOT_MATCH: 'The split payment amount does not match the invoice total advance.',
  DUPLICATE_FUNDING_TYPE: 'Duplicate payment option selected',
  DUPLICATE_PAYMENT_METHOD: 'Duplicate payment method selected',
  HOLD_RELEASE: 'Hold (+) / Release (-)',
  ADDITIONAL_FEES: 'Additional Fees',
  RESERVE_ESCROW: 'Reserve/Escrow',
  EXCEED_PARENT_CREDIT_LIMIT: 'New advance amount will exceed the parent "{parentCompanyName}" credit limit',
  UPDATE_INVOICE_FUEL_ADVANCE_SUCCESSFULLY: 'Invoice Fuel Advance Updated Successfully',
  BROKER_HAS_NOT_PAYMENT_METHOD: 'The broker has no payment options, the invoice cannot be purchased.',
  BROKER_DEBTOR: 'Broker Debtor',
  INVOICE_DETAILS: 'Invoice Details',
  UPDATE_AMOUNT_DETAILS: 'Update Amount Details',
  UPDATE_AMOUNT_DETAILS_SUCCESSFULLY: 'Updated Amount Details Successfully',
  AMOUNT_DETAILS: 'Amount Details',
  PREFERRED_PAYMENT_METHOD: 'Preferred Payment Method',
  FEE_AMOUNT_EXCEEDS_ORIGINAL: 'Fee amount {feeAmount} exceeds the original Scheduled Fee amount {originalAmount}',
  FEE_AMOUNT_CANNOT_BE_ZERO: 'The fee {feeName} amount cannot be zero',
  DUE_DATE: 'Due Date',
  DUE_DATE_CALCULATE_INFO: 'If left blank, due date will be calculated from Payment Term',
  //END Michael

  //BEGIN Fco
  INVOICE_DATE: 'Invoice Date',
  INVOICE_DATE_IN_FUTURE_WARNING: 'Invoice date is more than 15 days in the future',
  INVOICE_DATE_IN_PAST_WARNING: 'Invoice date is more than 90 days in the past',
  INVOICE_AMOUNT_LARGE_WARNING: 'Invoice amount exceeds $10,000',
  MAX_INVOICE_AMOUNT_WARNING: 'Exceeds your maximum invoice approval limit of {limit}',
  MAX_INVOICE_AMOUNT_BYPASS_WARNING: 'Exceeds your maximum invoice approval limit of {limit} — bypass active until {date}',
  INVOICES_EXCEED_MAX_INVOICE_AMOUNT: 'Invoice(s) {invoiceNumbers} exceed your maximum invoice approval limit of {limit}. Approval is blocked.',
  INVOICE_WARNINGS: 'Invoice Warnings',
  WARNINGS: 'Warnings',
  NO_BUY_WARNING_MESSAGE: 'is marked as No Buy',
  RISK_WARNINGS: 'Risk Warnings',
  CREDIT_WARNINGS: 'Credit Warnings',
  NO_BUY_WARNINGS: 'No Buy Warnings',
  ENTITY_CREDIT_LIMITS: 'Entity Credit Limits',
  RELATIONSHIP_CREDIT_LIMITS: 'Relationship Credit Limits',
  PARENT_HIERARCHY_LIMITS: 'Parent Hierarchy Limits',
  DOCUMENTS_ADDED_INVOICE: 'All documents were successfully added to the invoice',
  OPEN: 'Open',
  CLOSE: 'Close',
  CLOSED: 'Closed',
  COMBINED_DOCUMENTATION: 'Combined Documentation',
  BILLING_DOCUMENTATION: 'Billing Documentation',
  FACTOR_DEFAULT: 'Factor default',
  NOA_PLACEMENT: 'NOA Placement',
  NOA_PLACEMENT_FIRST: 'First page',
  NOA_PLACEMENT_AFTER_FC_INVOICE: 'After FC Invoice',
  NOA_PLACEMENT_LAST: 'Last page',
  REQUEST: 'Request',
  LOADING: 'Loading',
  ERROR_LOADING_DOCUMENT: 'Error loading document',
  ERROR_LOADING_CONTACTS: 'Error loading contacts',
  GENERATED_ON: 'Generated on',
  GENERATED_DOCUMENTS: 'Generated Documents',
  //END Fco

  //BEGIN Fabian
  CREATE_INVOICE_GROUP_CONFIRMATION: 'Are you sure you want to approve these invoices for funding?',
  REFERENCE: 'Reference',
  DATE: 'Date',
  NOTES: 'Notes',
  INVOICE_CREATED_SUCCESSFULLY: 'Invoice created successfully',
  CREATE_INVOICE: 'Create Invoice',
  QUICK_CREATE: 'Quick Create',
  INVOICE_AMOUNT: 'Invoice Amount',
  CLIENT_LIMIT: 'Client Limit',
  DEBTOR_LIMIT: 'Debtor Limit',
  CLIENT_DEBTOR_LIMIT: 'Client-Debtor Limit',
  CLIENT_DEBTOR: 'Client-Debtor',
  COMPANY_HAS_CREDIT_LIMIT_APPROVED: 'The {company} "{companyName}" does not have an approved credit limit.',
  CREDIT_LIMIT_WARNINGS: 'Credit Limit Warnings',
  NO_APPROVED_CREDIT_LIMIT: 'Does not have an approved credit limit',
  ZERO_CREDIT_LIMIT: 'Has an approved credit limit of {creditLimit}',
  CREDIT_LIMIT_EXCEED_DETAIL: 'Credit limit of {creditLimit} will be exceeded',
  CREDIT_LIMIT_EXPIRED_WARNING: 'Credit limit expired on {expirationDate}',
  CREDIT_LIMIT_EXPIRED_WARNING_NO_DATE: 'Credit limit has expired',
  CREDIT_LIMIT_REACHED: 'The credit limit has been reached ',
  ESCROW_RESERVE: 'Escrow Reserve',
  TOTAL_ADVANCE: 'Total Advance',
  CREATE_INVOICE_GROUP: 'Approve for Funding',
  CREATE_INVOICE_GROUP_SUCCESSFULLY: 'Invoices approved for funding',
  SUMMARY: 'Summary',
  CLIENT_SUMMARY: 'Client Summary',
  BROKER_SUMMARY: 'Broker Summary',
  APPROVE_FOR_FUNDING: 'Approve for Funding',
  CASH_RESERVE: 'Cash Reserve',
  FEES: 'Fees',
  NET_ADVANCE: 'Net Advance',
  RESERVE_RELEASE: 'Reserve Release',
  FUNDING_INSTRUCTIONS: 'Funding Instructions',
  NOT_PAYMENT_METHOD: 'The client has no payment options, the invoice cannot be purchased.',
  IGNORE_PAYMENT_FEE: 'Ignore payment fee',
  PROGRESS_TOOLTIP: 'Current open AR / New approved amount / Credit limit',
  CALENDAR_DAYS: 'Calendar Days',
  BUSINESS_DAYS: 'Business Days',
  MONDAY_FRIDAY: 'Monday-Friday',
  TOOLTIP_MESSAGE_FEE: 'These fees are for reference only and will be applied on funding.',
  CURRENT_OPEN_AR: 'Current Open AR',
  NEW_APPROVED_AMOUNT: 'New Approved Amount',
  CREDIT_LIMIT: 'Credit Limit',
  VERIFIED: 'Verified',
  NOT_VERIFIED: 'Not Verified',
  DENIED: 'Denied',
  INFORMATION: 'Information',
  VERIFICATION: 'Verification',
  VERIFICATION_LOGS: 'Verification Logs',
  VERIFICATION_STATUS: 'Verification Status',
  VERIFICATION_CONTACT: 'Verification Contact',
  PO_LOAD_NUMBER: 'PO / Load #',
  NO_CONTACT_ON_FILE: 'No contact on file',
  TOTAL_INVOICE_AMOUNT: 'Total Invoice Amount',
  VERIFY: 'Verify',
  VERIFY_WITH_AI_CALL: 'Verify with AI Call',
  INVOICES_VERIFY_SUCCESSFULLY: 'Invoices verified successfully',
  FEE_AMOUNT: 'Fee Amount',
  FUNDED_DATE: 'Funded Date',
  CLOSED_DATE: 'Closed Date',
  CALL_BACK_DATE: 'Call Back Date',
  WILL_PAY_DATE: 'Will Pay Date',
  DAYS_AGED: 'Days Aged',
  DAYS_OUTSTANDING: 'Days Outstanding',
  PAID_ON: 'Paid On',
  PAYMENT_STATUS: 'Payment Status',
  PAYMENT_STATUS_INFO:
    'This can be OPEN or CLOSED. Closed means it has been paid off, in any other case it will be open.',
  INVOICE_STATUS: 'Invoice Status',
  PAYMENT_TRANSACTION_NUMBER: 'Payment Transaction Number',
  MORE: 'More',
  LESS: 'Less',
  APPROVED: 'Approved',
  TERM_INFO_CREATE_BLADE: 'The term to be used for the invoice is: ',
  INVOICE_FORCED_TERM_MESSAGE: 'This is a custom forced term for the invoice.',
  INVOICE_TERM_EXPLANATION_FORCED: 'The term used for invoice is derived from the custom forced term.',
  INVOICE_TERM_EXPLANATION_CLIENT_DEBTOR:
    'The term used for the invoice is derived from the client-debtor relationship term or client term.',
  INVOICE_TERM_PRIORITY: 'The term used for the invoice has the following priority:',
  CUSTOM_FORCED_TERM: 'Custom forced term',
  CLIENT_DEBTOR_RELATIONSHIP_TERM: 'Client debtor relationship term',
  CLIENT_TERM: 'Client term',
  OVER_ADVANCE: 'Over Advance',
  OVER_ADVANCE_TYPE: 'Over Advance Type',
  CREATE_OVER_ADVANCE: 'Create Over Advance',
  UPDATE_OVER_ADVANCES_SUCCESSFULLY: 'Over Advances updated successfully',
  OOS: 'OOS',
  RESERVE_RELEASE_AMOUNT: 'Reserve Release Amount',
  TOTAL_NET_AMOUNT: 'Total Net Amount',
  EXPORT_INVOICES_SUCCESSFULLY: 'Invoices exported successfully',
  ARE_YOU_SURE_EXPORT_INVOICES: 'Are you sure you want to export the invoices?',
  EXPORT_INVOICES: 'Export Invoices',
  RESEND_BILLING_MESSAGE: 'You are about to resend the billing paperwork for {0} invoices.',
  RESEND_BILLING_MESSAGE_SINGLE: 'You are about to resend the billing paperwork for 1 invoice.',
  RESEND_BILLING_DESCRIPTION: 'Each invoice is regenerated and sent to its debtor separately.',
  REGENERATE_INVOICE: 'Regenerate Invoice',
  INVOICE_REEMERGE_MESSAGE:
    'Invoice page, invoice documents and NOA will reemerge, the old invoice will be moved to Inactive.',
  CONFIRM_REBILL: 'Confirm Rebill',
  REBILL_INVOICE_SUCCESSFULLY: 'Invoice rebilled successfully',
  REBILL: 'Rebill',
  REBILL_REGENERATE_INFO_MESSAGE:
    'Some of the selected invoices may not have their document regenerated if their client (or broker) does not support this feature — they will be resent with their existing documentation instead.',
  REBILL_LIMIT_EXCEEDED_TOOLTIP: 'At the moment we cannot rebill more than {0} invoices at once',
  REBILL_AMOUNT_TO_BILL: 'Amount to bill, per invoice',
  REBILL_AMOUNT_TO_BILL_SINGLE: 'Amount to bill',
  REBILL_COLUMN_INVOICE: 'Invoice',
  REBILL_COLUMN_ORIGINAL: 'Original',
  REBILL_COLUMN_BALANCE: 'Balance',
  REBILL_SELECT_ALL: 'Select all',
  REBILL_BALANCE_DISABLED_NOTE:
    'No payments applied yet — both columns bill the same figure, so Balance is disabled.',
  INVOICE_LINE_ITEM_CODE: 'Invoice Line Item Code',
  ADDITIONAL_CASH_RESERVE: 'Additional Cash Reserve',
  //END Fabian

  //BEGIN Patricio
  AP_BANK_ACCOUNT: 'AP Bank Account',
  AR_BANK_ACCOUNT: 'AR Bank Account',
  UPDATE_INVOICE_DETAILS_SUCCESSFULLY: 'Updated Invoice Details Successfully',
  UPDATE_INVOICE_NOTES_SUCCESSFULLY: 'Updated Invoice Notes Successfully',
  CREATED_ON: 'Created On',
  NUMBER_OF_INVOICES: 'Number of Invoices',
  DELETE_INVOICE: 'Delete Invoice',
  DELETE_INVOICE_CONFIRMATION: 'Are you sure you want to delete the selected invoices?',
  DELETION_OF_ALL_INVOICES_NOT_SUPPORTED: 'Deletion of all invoices across all pages is not supported',
  DELETE_INVOICE_SUCCESSFULLY: 'Invoice/s deleted successfully',
  DELETED: 'Deleted',
  METHOD: 'Method',
  AUTOGENERATED_DOCUMENT_MSG: 'This document was autogenerated by the system.',
  INVOICE_NUMBERS: 'Invoice Numbers',

  LINE_ITEMS: 'Line Items',
  INVOICE_LINE_ITEM_ID: 'Line Item ID',
  INVOICE_LINE_ITEM: 'Invoice Line Item',
  INVOICE_LINE_ITEMS: 'Invoice Line Items',
  INVOICE_LINE_ITEM_DESCRIPTION: 'Enable or disable Invoice Line Item',
  INVOICE_LINE_ITEM_CREATED_SUCCESSFULLY: 'Invoice Line Item created successfully',

  DELETE_INVOICE_LINE_ITEMS: 'Delete Invoice Line Items',
  DELETE_INVOICE_LINE_ITEMS_SUCCESSFULLY: 'Invoice Line Item/s deleted successfully',
  DELETE_INVOICE_LINE_ITEM_CONFIRMATION: 'Are you sure you want to delete the selected invoice line items?',

  UPDATE_INVOICE_LINE_ITEM: 'Update Invoice Line Item',
  UPDATE_INVOICE_LINE_ITEM_SUCCESSFULLY: 'Invoice Line Item updated successfully',

  INVOICE_LINE_ITEM_CODE_ERROR: 'Code cannot be empty',
  LINE_ITEM_CODE_LENGTH_ERROR: 'The code must be less than 50 characters',
  LUNE_ITEM_CODE_DUPLICATE_ERROR: 'The code must be unique',

  FEE_ESCROW: 'Fee Escrow',
  //END Patricio

  //BEGIN Esteban
  VERIFY_STATUS_DENIED: 'Denied',
  VERIFY_STATUS_NOT_VERIFIED: 'Not verified',
  VERIFY_STATUS_PENDING: 'Pending',
  VERIFY_STATUS_VERIFIED: 'Verified',
  ERROR_REPORT_CONFIRMATION:
    'There were errors processing the CSV file, no new invoices were created. To see the error report, download the attached file.',
  RESERVES_FEE_NOTES: 'Hold / Release Notes',
  ADDITIONAL_FEE_NOTES: 'Additional Fee Notes',
  NON_FACTORED_INVOICE: 'Nonfactored Invoice',
  RECOURSE: 'Recourse',
  NF: 'NF',
  SELECTED_LABELS: 'Selected Labels',
  CREDIT_LIMITS: 'Credit Limits',
  EXPORT_INVOICE_LINE_ITEMS: 'Export Invoice Line Items',
  //END Esteban
  UPDATE_INVOICES: 'Update Invoices',
  UPDATE_INVOICE: 'Update Invoice',
  MULTIPLE_INVOICES_UPDATE_WARNING:
    'Once you submit this form, <strong>all associated invoices</strong> will be <strong>updated</strong> with the information you have provided. Please ensure all details are correct before proceeding.',
  COMPANY_DETAILS: '{0} Company Details',
  INVOICE_CONDITIONS: 'Invoice Conditions',

  OUTDATED: 'Outdated',
  INVOICE_NUMBER_ALREADY_EXISTS: 'This invoice number already exists for this Company',
  REFERENCE_NUMBER_ALREADY_EXISTS: 'This reference number already exists for invoice number{0} {1}',
  REFERENCE_NUMBER_EXISTS_IN_REJECTED:
    'This reference number was found in a rejected invoice. You can proceed with creation.',
  CHANGELOG_CATEGORY_ALL: 'All',
  CHANGELOG_CATEGORY_GENERAL: 'General',
  CHANGELOG_CATEGORY_COLLECTIONS: 'Collection',
  COLLECTIONS_STATUS: 'Collections Status',
  INVOICE_ADD_AS_NEW_DEBTOR: 'Add "{name}" as a new debtor',
  INVOICE_ADD_NEW_DEBTOR: 'Add a new debtor',
  INVOICE_NO_RELATED_DEBTORS: 'No debtors related to {name}',
  INVOICE_CREATE_DEBTOR_TITLE: 'Create Debtor',
  INVOICE_LINK_DEBTOR_TITLE: 'Link Debtor',
  INVOICE_RELATIONSHIP_WITH: 'Relationship with {name}',
  INVOICE_CREATE_AND_ASSIGN: 'Create & Assign',
  INVOICE_LINK_AND_ASSIGN: 'Link & Assign',
  INVOICE_USE_THIS_DEBTOR: 'Use this debtor',
  INVOICE_CREATE_NEW_DEBTOR_INSTEAD: 'Create a new one instead',
  INVOICE_DEBTOR_CREATED_AND_RELATED: '{debtor} was created and related to {company}',
  INVOICE_DEBTOR_RELATED: '{debtor} is now related to {company}',
  INVOICE_DEBTOR_CREATED_RELATIONSHIP_FAILED:
    '{debtor} was created, but the relationship could not be saved. Fix the relationship fields and try again.',

  APPLIED_TRANSACTIONS: 'Applied Transactions',
  NO_APPLIED_TRANSACTIONS: 'No applied transactions found for this invoice.',
  WRITE_OFF: 'Write Off',
  PAYMENT_TYPE_PARTIAL_FULL: 'Partial Full',
}

export const invoicesEs: typeof invoicesEn = {
  //BEGIN Michael
  INVOICE: 'Factura',
  INVOICES: 'Facturas',

  ONLY_CLIENTS_WITH_INVOICES_SHOWN: 'Aquí solo se muestran los clientes con facturas.',
  ONLY_CLIENTS_BROKERS_WITH_INVOICES_SHOWN: 'Aquí solo se muestran los clientes/brokers con facturas.',
  ONLY_DEBTORS_WITH_INVOICES_SHOWN: 'Aquí solo se muestran los deudores con facturas.',

  PENDING: {
    SINGLE: 'Pendiente',
    PLURAL: 'Pendientes',
  },
  APPROVED_FOR_FUNDING: {
    SINGLE: 'Aprobada para Financiamiento',
    PLURAL: 'Aprobadas para Financiamiento',
  },
  FUNDED: {
    SINGLE: 'Financiada',
    PLURAL: 'Financiadas',
  },
  PAID: {
    SINGLE: 'Pagada',
    PLURAL: 'Pagadas',
  },

  INVOICE_NUMBER: 'Número de factura',
  REFERENCE_NUMBER: 'Número de referencia',
  BALANCE: {
    SINGLE: 'Balance',
    PLURAL: 'Balances',
  },
  TOTAL_INVOICES_PAYMENT: 'Total de pagos de facturas',
  ESCROW: 'Fideicomiso',
  INVOICE_BALANCE: 'Balance de la factura',
  REMAINING_INVOICE_BALANCE: 'Balance restante',
  ADVANCE_AMOUNT: 'Monto del anticipo',
  BATCH_AMOUNT: 'Monto del lote',
  ESCROW_RESERVE_AMOUNT: 'Monto de la reserva de garantía',
  CASH_RESERVE_AMOUNT: 'Monto de la reserva de efectivo',
  REMAINING_CREDIT_LIMIT: 'Límite de crédito restante',
  PURCHASE_FEE_AMOUNT: 'Monto de la tarifa de compra',
  ESCROW_FEE_AMOUNT: 'Monto de la tarifa de fideicomiso',
  ADVANCE_AMOUNT_CANNOT_BE_NEGATIVE: 'El monto del anticipo no puede ser negativo',
  INVOICE_FEE: 'Tasa de la factura',
  ACH_FEES: 'Tasa ACH',
  WIRE_FEES: 'Tasa de transferencia',
  CHECK_FEES: 'Tasa de cheque',
  FUEL_CARD_FEES: 'Tasa de tarjeta de combustible',
  SAME_DAY_ACH_FEES: 'Tasa ACH del mismo día',
  INVOICES_APPROVED_FOR_FUNDING_SUCCESSFULLY: '¡Facturas aprobadas para financiamiento exitosamente!',
  REJECTED: 'Rechazado',
  REJECT: 'Rechazar',
  REJECT_INVOICE: 'Rechazar factura',
  INVOICE_REJECTED_SUCCESSFULLY: '¡Factura/s rechazada/s exitosamente!',
  INVOICE_PENDING_SUCCESSFULLY: '¡Factura/s movida/s a pendiente exitosamente!',
  REJECT_CONFIRMATION: '¿Está seguro de que desea rechazar las facturas seleccionadas?',
  UNLINK_FUEL_ADVANCE_CONFIRMATION:
    'Una o más de las facturas seleccionadas tienen un Anticipo de Combustible vinculado. Al rechazar se desvinculará el Anticipo de Combustible y volverá a estado Abierto. ¿Desea continuar?',
  UNLINK_AND_REJECT: 'Desvincular y Rechazar',
  PENDING_CONFIRMATION: '¿Está seguro de que desea mover a pendiente las facturas seleccionadas?',
  INVOICES_WERE_SELECTED_FOR_THIS_ACTION: 'facturas fueron seleccionadas para esta acción',
  MOVE_TO_PENDING: 'Mover a Pendiente',
  MOVE_TO_REJECTED: 'Mover a Rechazado',
  DEBTOR_CREDIT_LIMIT: 'Límite de crédito del deudor',
  CLIENT_DEBTOR_CREDIT_LIMIT: 'Límite de crédito del cliente-deudor',
  DEBTOR_CREDIT: 'Crédito del deudor',
  CLIENT_DEBTOR_CREDIT: 'Crédito del cliente-deudor',
  DEBTOR_CREDIT_INFO: 'Información de crédito del deudor',
  CLIENT_DEBTOR_CREDIT_INFO: 'Información de crédito del cliente-deudor',
  DEBTOR_CREDIT_SCORE: 'Puntaje de crédito del deudor',
  AVERAGE_DAYS_TO_PAY: 'Días promedio para pagar',
  INVOICES_RISK_PAST_DUE: 'Facturas en riesgo de vencimiento',
  INVOICES_PAST_DUE: 'Facturas vencidas',
  NO_LIMIT: 'Sin límite',
  SPLIT: 'Dividido',
  SPLIT_FUNDING: 'Financiamiento dividido',
  SPLIT_PAYMENT_AMOUNT_NOT_MATCH: 'El monto del pago dividido no coincide con el anticipo total de la factura.',
  DUPLICATE_FUNDING_TYPE: 'Tipo de financiamiento duplicado',
  DUPLICATE_PAYMENT_METHOD: 'Método de pago duplicado',
  HOLD_RELEASE: 'mantener (+) / liberar (-)',
  ADDITIONAL_FEES: 'Tarifas adicionales',
  RESERVE_ESCROW: 'Reserva/Fideicomiso',
  EXCEED_PARENT_CREDIT_LIMIT:
    'El nuevo monto del anticipo excederá el límite de crédito del padre "{parentCompanyName}"',
  UPDATE_INVOICE_FUEL_ADVANCE_SUCCESSFULLY: 'Anticipo de combustible de factura actualizado con éxito',
  BROKER_HAS_NOT_PAYMENT_METHOD: 'El broker no tiene opciones de pago, la factura no puede ser comprada.',
  BROKER_DEBTOR: 'Deudor del broker',
  INVOICE_DETAILS: 'Detalles de la factura',
  UPDATE_AMOUNT_DETAILS: 'Actualizar detalles del monto',
  UPDATE_AMOUNT_DETAILS_SUCCESSFULLY: 'Detalles del monto actualizados con éxito',
  AMOUNT_DETAILS: 'Detalles del monto',
  PREFERRED_PAYMENT_METHOD: 'Método de pago preferido',
  FEE_AMOUNT_EXCEEDS_ORIGINAL:
    'El monto de la tarifa {feeAmount} excede el monto original de la tarifa programada {originalAmount}',
  FEE_AMOUNT_CANNOT_BE_ZERO: 'El monto de la tarifa {feeName} no puede ser cero',
  DUE_DATE: 'Fecha de vencimiento',
  DUE_DATE_CALCULATE_INFO: 'Si se deja en blanco, la fecha de vencimiento se calculará a partir del término de pago',
  //END Michael

  //BEGIN Fco
  INVOICE_DATE: 'Fecha de la factura',
  INVOICE_DATE_IN_FUTURE_WARNING: 'La fecha de la factura es más de 15 días en el futuro',
  INVOICE_DATE_IN_PAST_WARNING: 'La fecha de la factura es más de 90 días en el pasado',
  INVOICE_AMOUNT_LARGE_WARNING: 'El monto de la factura supera $10,000',
  MAX_INVOICE_AMOUNT_WARNING: 'Excede tu límite máximo de aprobación de {limit}',
  MAX_INVOICE_AMOUNT_BYPASS_WARNING: 'Excede tu límite máximo de aprobación de {limit} — bypass activo hasta {date}',
  INVOICES_EXCEED_MAX_INVOICE_AMOUNT: 'La(s) factura(s) {invoiceNumbers} exceden tu límite máximo de aprobación de {limit}. La aprobación está bloqueada.',
  INVOICE_WARNINGS: 'Advertencias de Factura',
  WARNINGS: 'Advertencias',
  NO_BUY_WARNING_MESSAGE: 'está marcado como No compra',
  RISK_WARNINGS: 'Advertencias de Riesgo',
  CREDIT_WARNINGS: 'Advertencias de Crédito',
  NO_BUY_WARNINGS: 'Advertencias de No Compra',
  ENTITY_CREDIT_LIMITS: 'Límites de Crédito de Entidad',
  RELATIONSHIP_CREDIT_LIMITS: 'Límites de Crédito de Relación',
  PARENT_HIERARCHY_LIMITS: 'Límites de Jerarquía Padre',
  DOCUMENTS_ADDED_INVOICE: 'Todos los documentos han sido añadidos a la Factura.',
  OPEN: 'Abiertas',
  CLOSE: 'Cerrar',
  CLOSED: 'Cerradas',
  COMBINED_DOCUMENTATION: 'Documentación',
  BILLING_DOCUMENTATION: 'Documentación de Facturación',
  FACTOR_DEFAULT: 'Predeterminado del factor',
  NOA_PLACEMENT: 'Posición del NOA',
  NOA_PLACEMENT_FIRST: 'Primera página',
  NOA_PLACEMENT_AFTER_FC_INVOICE: 'Después de la factura FC',
  NOA_PLACEMENT_LAST: 'Última página',
  REQUEST: 'Solicitar',
  LOADING: 'Cargando',
  ERROR_LOADING_DOCUMENT: 'Error al cargar el documento',
  ERROR_LOADING_CONTACTS: 'Error al cargar los contactos',
  GENERATED_ON: 'Generado el',
  GENERATED_DOCUMENTS: 'Documentos Generados',
  //END Fco

  //BEGIN Fabian
  CREATE_INVOICE_GROUP_CONFIRMATION:
    '¿Está seguro de que desea añadir las facturas seleccionadas al grupo de facturas?',
  REFERENCE: 'Referencia',
  DATE: 'Fecha',
  NOTES: 'Notas',
  INVOICE_CREATED_SUCCESSFULLY: 'Factura creada exitosamente',
  CREATE_INVOICE: 'Crear Factura',
  QUICK_CREATE: 'Crear Rápido',
  INVOICE_AMOUNT: 'Importe de la factura',
  COMPANY_HAS_CREDIT_LIMIT_APPROVED: 'El {company} {companyName} no tiene un límite de crédito aprobado.',
  CREDIT_LIMIT_WARNINGS: 'Advertencias de Límite de Crédito',
  NO_APPROVED_CREDIT_LIMIT: 'No tiene un límite de crédito aprobado',
  ZERO_CREDIT_LIMIT: 'Tiene un límite de crédito aprobado de {creditLimit}',
  CREDIT_LIMIT_EXCEED_DETAIL: 'El límite de crédito de {creditLimit} será excedido',
  CREDIT_LIMIT_EXPIRED_WARNING: 'El límite de crédito expiró el {expirationDate}',
  CREDIT_LIMIT_EXPIRED_WARNING_NO_DATE: 'El límite de crédito ha expirado',
  CLIENT_LIMIT: 'Límite del cliente',
  DEBTOR_LIMIT: 'Límite del deudor',
  CLIENT_DEBTOR_LIMIT: 'Límite del cliente-deudor',
  CLIENT_DEBTOR: 'Cliente-Deudor',
  CREDIT_LIMIT_REACHED: 'Se ha alcanzado el límite de crédito',
  ESCROW_RESERVE: 'Reserva de garantía',
  TOTAL_ADVANCE: 'Total de anticipos',
  CREATE_INVOICE_GROUP: 'Crear Grupo de Facturas',
  CREATE_INVOICE_GROUP_SUCCESSFULLY: '¡Grupo de Facturas creado exitosamente!',
  SUMMARY: 'Resumen',
  CLIENT_SUMMARY: 'Resumen del Cliente',
  BROKER_SUMMARY: 'Resumen del Broker',
  APPROVE_FOR_FUNDING: 'Aprobar para financiamiento',
  CASH_RESERVE: 'Reserva de efectivo',
  FEES: 'Tarifas',
  NET_ADVANCE: 'Anticipo neto',
  RESERVE_RELEASE: 'Liberación de reserva',
  FUNDING_INSTRUCTIONS: 'Instrucciones de financiamiento',
  NOT_PAYMENT_METHOD: 'El cliente no tiene opciones de pago, la factura no puede ser comprada.',
  IGNORE_PAYMENT_FEE: 'Ignorar tarifa de pago',
  PROGRESS_TOOLTIP: 'Cuenta por cobrar actual / Nuevo monto aprobado / Límite de crédito',
  CALENDAR_DAYS: 'Días calendario',
  BUSINESS_DAYS: 'Días hábiles',
  MONDAY_FRIDAY: 'Lunes-Viernes',
  TOOLTIP_MESSAGE_FEE: 'Estas tarifas son solo de referencia y se aplicarán al financiamiento.',
  CURRENT_OPEN_AR: 'Cuenta por cobrar actual',
  NEW_APPROVED_AMOUNT: 'Nuevo monto aprobado',
  CREDIT_LIMIT: 'Límite de crédito',
  VERIFIED: 'Verificado',
  NOT_VERIFIED: 'No verificado',
  DENIED: 'Denegado',
  INFORMATION: 'Información',
  VERIFICATION: 'Verificación',
  VERIFICATION_LOGS: 'Registros de verificación',
  VERIFICATION_STATUS: 'Estado de verificación',
  VERIFICATION_CONTACT: 'Contacto de verificación',
  PO_LOAD_NUMBER: 'PO / Carga #',
  NO_CONTACT_ON_FILE: 'Sin contacto registrado',
  TOTAL_INVOICE_AMOUNT: 'Monto total de facturas',
  VERIFY: 'Verificar',
  VERIFY_WITH_AI_CALL: 'Verificar con Llamada de IA',
  INVOICES_VERIFY_SUCCESSFULLY: 'Facturas verificadas exitosamente',
  FEE_AMOUNT: 'Monto de la tarifa',
  FUNDED_DATE: 'Fecha de financiamiento',
  CLOSED_DATE: 'Fecha de cierre',
  CALL_BACK_DATE: 'Fecha de llamada',
  WILL_PAY_DATE: 'Fecha de pago',
  DAYS_AGED: 'Días de antigüedad',
  DAYS_OUTSTANDING: 'Días pendientes',
  PAID_ON: 'Pagado el',
  PAYMENT_STATUS: 'Estado de pago',
  PAYMENT_STATUS_INFO:
    'Esto puede ser ABIERTO o CERRADO. Cerrado significa que ha sido pagado, en cualquier otro caso estará abierto.',
  INVOICE_STATUS: 'Estado de la factura',
  PAYMENT_TRANSACTION_NUMBER: 'Número de transacción de pago',
  MORE: 'Más',
  LESS: 'Menos',
  APPROVED: 'Aprobado',
  TERM_INFO_CREATE_BLADE: 'El término a utilizar para la factura es: ',
  INVOICE_FORCED_TERM_MESSAGE: 'Este es un término forzado personalizado para la factura.',
  INVOICE_TERM_EXPLANATION_FORCED: 'El término utilizado para la factura se deriva del término personalizado.',
  INVOICE_TERM_EXPLANATION_CLIENT_DEBTOR:
    'El término utilizado para la factura se deriva del término de la relación cliente-deudor o del término del cliente.',
  INVOICE_TERM_PRIORITY: 'El término utilizado para la factura tiene la siguiente prioridad:',
  CUSTOM_FORCED_TERM: 'Término forzado personalizado',
  CLIENT_DEBTOR_RELATIONSHIP_TERM: 'Término de la relación cliente-deudor',
  CLIENT_TERM: 'Término del cliente',
  OVER_ADVANCE: 'Sobre anticipos',
  OVER_ADVANCE_TYPE: 'Tipo de sobre anticipos',
  CREATE_OVER_ADVANCE: 'Crear sobre anticipos',
  UPDATE_OVER_ADVANCES_SUCCESSFULLY: 'Sobre anticipos actualizados exitosamente',
  OOS: 'OOS',
  RESERVE_RELEASE_AMOUNT: 'Monto de liberación de reserva',
  TOTAL_NET_AMOUNT: 'Monto neto total',
  EXPORT_INVOICES_SUCCESSFULLY: 'Facturas exportadas exitosamente',
  ARE_YOU_SURE_EXPORT_INVOICES: '¿Está seguro de que desea exportar las facturas?',
  EXPORT_INVOICES: 'Exportar Facturas',
  RESEND_BILLING_MESSAGE: 'Estás a punto de reenviar la documentación de facturación de {0} facturas.',
  RESEND_BILLING_MESSAGE_SINGLE: 'Estás a punto de reenviar la documentación de facturación de 1 factura.',
  RESEND_BILLING_DESCRIPTION: 'Cada factura se regenera y se envía a su deudor por separado.',
  REGENERATE_INVOICE: 'Regenerar Factura',
  INVOICE_REEMERGE_MESSAGE:
    'La página de la factura, los documentos de la factura y NOA volverán a aparecer, la antigua factura se moverá a Inactiva.',
  CONFIRM_REBILL: 'Confirmar Rebill',
  REBILL_INVOICE_SUCCESSFULLY: 'Factura reenviada exitosamente',
  REBILL: 'Rebill',
  REBILL_REGENERATE_INFO_MESSAGE:
    'Algunas de las facturas seleccionadas podrían no regenerar su documento si su cliente (o corredor) no soporta esta función — en ese caso se reenviarán con su documentación existente.',
  REBILL_LIMIT_EXCEEDED_TOOLTIP: 'Por el momento no podemos rebillear más de {0} facturas a la vez',
  REBILL_AMOUNT_TO_BILL: 'Monto a facturar, por factura',
  REBILL_AMOUNT_TO_BILL_SINGLE: 'Monto a facturar',
  REBILL_COLUMN_INVOICE: 'Factura',
  REBILL_COLUMN_ORIGINAL: 'Original',
  REBILL_COLUMN_BALANCE: 'Balance',
  REBILL_SELECT_ALL: 'Seleccionar todo',
  REBILL_BALANCE_DISABLED_NOTE:
    'Aún no hay pagos aplicados — ambas columnas facturan el mismo monto, por eso Balance está deshabilitado.',
  INVOICE_LINE_ITEM_CODE: 'Código del elemento de la factura',
  ADDITIONAL_CASH_RESERVE: 'Reserva de efectivo adicional',
  //END Fabian

  //BEGIN Patricio
  AP_BANK_ACCOUNT: 'Cuenta Bancaria AP',
  AR_BANK_ACCOUNT: 'Cuenta Bancaria AR',
  UPDATE_INVOICE_DETAILS_SUCCESSFULLY: 'Los detalles del Invoice se actualizaron exitosamente',
  UPDATE_INVOICE_NOTES_SUCCESSFULLY: 'Las notas del Invoice se actualizaron exitosamente',
  CREATED_ON: 'Creado el',
  NUMBER_OF_INVOICES: 'Número de Facturas',
  DELETE_INVOICE: 'Eliminar Factura',
  DELETE_INVOICE_CONFIRMATION: '¿Está seguro de que desea eliminar las facturas seleccionadas?',
  DELETION_OF_ALL_INVOICES_NOT_SUPPORTED: 'No se admite la eliminación de todas las facturas en todas las páginas',
  DELETE_INVOICE_SUCCESSFULLY: '¡Factura/s eliminada/s exitosamente!',
  DELETED: 'Eliminado',
  METHOD: 'Método',
  AUTOGENERATED_DOCUMENT_MSG: 'Este documento fue generado automáticamente por el sistema.',
  INVOICE_NUMBERS: 'Números de Facturas',

  LINE_ITEMS: 'Líneas de Factura',
  INVOICE_LINE_ITEM_ID: 'ID Elemento de Factura',
  INVOICE_LINE_ITEM: 'Elementos de la factura',
  INVOICE_LINE_ITEMS: 'Elementos de la factura',
  INVOICE_LINE_ITEM_DESCRIPTION: 'Habilitar o deshabilitar el detalle de la factura',
  INVOICE_LINE_ITEM_CREATED_SUCCESSFULLY: 'Elemento de la factura creado exitosamente',

  DELETE_INVOICE_LINE_ITEMS: 'Eliminar Elementos de la Factura',
  DELETE_INVOICE_LINE_ITEMS_SUCCESSFULLY: '¡Elemento/s de la factura eliminado/s exitosamente!',
  DELETE_INVOICE_LINE_ITEM_CONFIRMATION:
    '¿Está seguro de que desea eliminar los elementos de la factura seleccionados?',

  UPDATE_INVOICE_LINE_ITEM: 'Actualizar Elemento de la Factura',
  UPDATE_INVOICE_LINE_ITEM_SUCCESSFULLY: 'Elemento de la factura actualizado exitosamente',

  INVOICE_LINE_ITEM_CODE_ERROR: 'El código no puede estar vacío',
  LINE_ITEM_CODE_LENGTH_ERROR: 'El código debe tener menos de 50 caracteres',
  LUNE_ITEM_CODE_DUPLICATE_ERROR: 'El código debe ser único',

  FEE_ESCROW: 'Tarifa de Garantía',
  //END Patricio

  //BEGIN Esteban
  VERIFY_STATUS_DENIED: 'Denegado',
  VERIFY_STATUS_NOT_VERIFIED: 'No verificado',
  VERIFY_STATUS_PENDING: 'Pendiente',
  VERIFY_STATUS_VERIFIED: 'Verificado',
  ERROR_REPORT_CONFIRMATION:
    'Hubieron errores al procesar el archivo CSV, no se crearon facturas nuevas. Parar ver el reporte de errores, descargue el archivo adjunto',
  RESERVES_FEE_NOTES: 'Notas de tarifas de reservas',
  ADDITIONAL_FEE_NOTES: 'Notas de tarifas adicionales',
  NON_FACTORED_INVOICE: 'Factura no factorizada',
  RECOURSE: 'Con Recurso',
  NF: 'NF',
  SELECTED_LABELS: 'Etiquetas seleccionadas',
  CREDIT_LIMITS: 'Límites de crédito',
  EXPORT_INVOICE_LINE_ITEMS: 'Exportar elementos de la factura',
  //END Esteban
  UPDATE_INVOICES: 'Actualizar Facturas',
  UPDATE_INVOICE: 'Actualizar Factura',
  MULTIPLE_INVOICES_UPDATE_WARNING:
    'Una vez que envíe este formulario, **todas las facturas asociadas** se actualizarán con la información que ha proporcionado. Asegúrese de que todos los detalles sean correctos antes de continuar.',
  COMPANY_DETAILS: 'Detalles de {0}',
  INVOICE_CONDITIONS: 'Condición de Facturas',

  OUTDATED: 'Desactualizado',
  INVOICE_NUMBER_ALREADY_EXISTS: 'Este número de factura ya existe para esta empresa',
  REFERENCE_NUMBER_ALREADY_EXISTS: 'Este número de referencia ya existe para factura{0} con número {1}',
  REFERENCE_NUMBER_EXISTS_IN_REJECTED:
    'Este número de referencia se encontró en una factura rechazada. Puede proceder con la creación.',
  CHANGELOG_CATEGORY_ALL: 'Todos',
  CHANGELOG_CATEGORY_GENERAL: 'General',
  CHANGELOG_CATEGORY_COLLECTIONS: 'Cobranza',
  COLLECTIONS_STATUS: 'Estado de Cobranzas',
  INVOICE_ADD_AS_NEW_DEBTOR: 'Agregar "{name}" como nuevo deudor',
  INVOICE_ADD_NEW_DEBTOR: 'Agregar un nuevo deudor',
  INVOICE_NO_RELATED_DEBTORS: 'No hay deudores relacionados con {name}',
  INVOICE_CREATE_DEBTOR_TITLE: 'Crear Deudor',
  INVOICE_LINK_DEBTOR_TITLE: 'Vincular Deudor',
  INVOICE_RELATIONSHIP_WITH: 'Relación con {name}',
  INVOICE_CREATE_AND_ASSIGN: 'Crear y Asignar',
  INVOICE_LINK_AND_ASSIGN: 'Vincular y Asignar',
  INVOICE_USE_THIS_DEBTOR: 'Usar este deudor',
  INVOICE_CREATE_NEW_DEBTOR_INSTEAD: 'Crear uno nuevo',
  INVOICE_DEBTOR_CREATED_AND_RELATED: '{debtor} fue creado y relacionado con {company}',
  INVOICE_DEBTOR_RELATED: '{debtor} ahora está relacionado con {company}',
  INVOICE_DEBTOR_CREATED_RELATIONSHIP_FAILED:
    '{debtor} fue creado, pero la relación no se pudo guardar. Corrija los campos de la relación e intente de nuevo.',

  APPLIED_TRANSACTIONS: 'Transacciones Aplicadas',
  NO_APPLIED_TRANSACTIONS: 'No se encontraron transacciones aplicadas para esta factura.',
  WRITE_OFF: 'Write Off',
  PAYMENT_TYPE_PARTIAL_FULL: 'Parcial Completo',
}
